import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Component } from 'react';
import { Stack } from 'react-bootstrap';
import './menu.scss';
import { cockpit } from '@/shared/scripts/shared/models/cockpit.model';

export type MenuItem = {
  title: string;
  url: string;
  target: string;
  classes: string[];
};

type State = {
  showOffCanvas: boolean;
};

export class Menu extends Component<any, State> {
  state: State = {
    showOffCanvas: false,
  };

  handleShow = () => {
    this.setState({ showOffCanvas: true });
  };

  handleClose = () => {
    this.setState({ showOffCanvas: false });
  };

  render() {
    const menuItems: MenuItem[] = cockpit?.navigation_head ?? [];
    const phone = cockpit?.footer_phone_phone ?? '';
    const whatsapp = cockpit?.footer_phone_whatsapp ?? '';

    return (
      <>
        {['xl'].map((expand) => (
          <Navbar key={expand} expand={expand} className={'d-xl-none py-0'}>
            <Container fluid>
              <Navbar.Toggle className={'border-0 me-0'} onClick={this.handleShow} />
              <Navbar.Offcanvas
                className={'header-navbar-main'}
                show={this.state.showOffCanvas}
                onHide={this.handleClose}
                id={`offcanvasNavbar-expand-${expand}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                placement="end"
              >
                <Offcanvas.Header closeButton></Offcanvas.Header>
                <Offcanvas.Body className={'vstack gap-3'}>
                  <Nav className="text-center fs-4">
                    {menuItems.map((item) => (
                      <Nav.Link className={`${[...item.classes, ...['fs-5 py-1 text-uppercase']].filter((c) => c).join(' ')}`} href={item.url} target={item.target}>
                        {item.title}
                      </Nav.Link>
                    ))}
                  </Nav>

                  <Stack gap={2} className="justify-content-end flex-column text-center pb-5">
                    <div className={'d-flex align-items-center justify-content-center'}>
                      <div className={'text-bg-primary px-3 py-2 rounded-5'}>WhatsApp: {whatsapp}</div>
                    </div>
                    <div>
                      <a className="btn btn-lg btn-primary" href={`tel:${phone.replace(/ /g, '')}`}>
                        <div className={'d-flex align-items-center'}>
                          <i className={'icon icon-phone me-2'} /> {phone}
                        </div>
                      </a>
                    </div>
                  </Stack>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        ))}
      </>
    );
  }
}
